import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET_OTHER_QUOTE_LIST } from "../../../../../common/constant";
import { post } from "../../../../../common/api";


export const actionGetOtherQuoteList = createAsyncThunk(
    "otherQuoteListStore/actionGetOtherQuoteList",
    async(params, thunkAPI) => {
        return await post(GET_OTHER_QUOTE_LIST, params, thunkAPI);
    }
)




// START
export const otherQuoteListSlice = createSlice({
name: "otherQuoteListStore",
initialState: {

     // Get Other Quote List 
    loadingGetOtherQuoteList: false,
    getOtherQuoteList: null,
},
reducers: {
    //reset or delete public store data
    resetGetOtherQuoteList: (state) => {
        state.getOtherQuoteList = null;
    }
},
extraReducers: (builder) => {
    builder
    .addCase(actionGetOtherQuoteList.pending, (state) => {
        state.loadingGetOtherQuoteList = true;
    })
    .addCase(actionGetOtherQuoteList.fulfilled, (state, action) =>{
        state.loadingGetOtherQuoteList = true;
        state.getOtherQuoteList = action.payload;
    })
    .addCase(actionGetOtherQuoteList.rejected, (state) => {
        state.loadingGetOtherQuoteList = false;
    })
},
});
// END


// Reset Export
export const {resetGetOtherQuoteList} = otherQuoteListSlice.actions;

export default otherQuoteListSlice.reducer;